import { render } from "./c-column.vue?vue&type=template&id=f9266492"
import script from "./c-column.vue?vue&type=script&lang=js"
export * from "./c-column.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__